function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Filter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "FilterIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "m20.35 5.76-5.628 6.397A3 3 0 0 0 14 14.11V20l-3 2v-7.89a3 3 0 0 0-.722-1.953L4.65 5.76A2.703 2.703 0 0 1 4 4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1c0 .645-.23 1.27-.65 1.76z"
    })
  }));
});
Filter.displayName = 'FilterIcon';
export default Filter;